import Billing from './premium/Billing';
import React from "react";
import ProfileVisitGate from './premium/ProfileVisitGate';
import { Route, Routes } from "react-router-dom";
import './App.css';
import './componentsL/ModalAnimations.css';
import './mobile-native.css';
import Login from "./auth/Login";
import LoginTransition from "./auth/LoginTransition";
import ProtectedRoutes from './components/ProtectedRoutes';
import Main from "./mainwebsite/Main/Main";
import Admin from "./pages/dashboards/Admin";
import SportProfile from "./componentsL/SportProfile";
import Settings from "./componentsL/Settings";
import Register from "./auth/register/Register";
import { ConfirmModalProvider } from "./components/reusable/ConfirmModalContext";
import ConfirmModal from "./components/reusable/ConfirmModal";
import ProfileSettings from "./componentsL/ProfileSettings/ProfileSettings";
import Conversations from "./componentsL/Conversations";
import OfferDetails from "./componentsL/OfferDetails";
import ClubOffers from "./componentsL/ClubOffers";
import OfferApplications from "./componentsL/OfferApplications";
import LoginRequiredModal from "./components/reusable/LoginRequiredModal";
import { LoginRequiredProvider } from "./components/reusable/LoginRequiredContext";

import AdminProtectedRoute from "./admin/routes/AdminProtectedRoute";
import AdminLayout from "./admin/layouts/AdminLayout";
import AdminUsers from "./admin/pages/AdminUsers";
import AdminUserDetails from "./admin/pages/AdminUserDetails";

import { Navigate } from "react-router-dom";
import MobileRuntime from "./mobile/MobileRuntime";
import { Capacitor } from "@capacitor/core";
import { hydrateRememberedSession } from "./store/Store";
import PrivacyPolicy from "./mainwebsite/PrivacyPolicy/PrivacyPolicy";
import ChildSafety from "./mainwebsite/ChildSafety/ChildSafety";



function App() {

  hydrateRememberedSession();
  const nativeHome = sessionStorage.getItem("token") ? "/home" : "/login";

  return (

    <ConfirmModalProvider>

      <LoginRequiredProvider>
        <MobileRuntime />

        <Routes>
          <Route
            path="/"
            element={
              Capacitor.isNativePlatform()
                ? <Navigate to={nativeHome} replace />
                : <Main />
            }
          />
          <Route path="/login" element={<Login />} />
          <Route path="/welcome" element={
            <ProtectedRoutes>
              <LoginTransition />
            </ProtectedRoutes>
          } />
          <Route path="/billing" element={<ProtectedRoutes><Billing /></ProtectedRoutes>} />
          <Route path="/register" element={<Register />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/child-safety" element={<ChildSafety />} />

          <Route path="/home" element={
            <ProtectedRoutes>
              <Admin />
            </ProtectedRoutes>
          } />


          <Route path="/user/:username" element={
            // <ProtectedRoutes>
            <SportProfile />
            // </ProtectedRoutes>
          } />

          {/* admin */}

          <Route
            path="/admin"
            element={
              <AdminProtectedRoute>
                <AdminLayout />
              </AdminProtectedRoute>
            }
          >
            <Route
              index
              element={
                <Navigate
                  to="users"
                  replace
                />
              }
            />

            <Route
              path="users"
              element={
                <AdminUsers />
              }
            />

            <Route
              path="users/:id"
              element={
                <AdminUserDetails />
              }
            />
          </Route>



          <Route
            path="/settings"
            element={
              <ProtectedRoutes>
                <Settings />
              </ProtectedRoutes>
            }
          />


          <Route
            path="/profile/settings"
            element={
              <ProtectedRoutes>
                <ProfileSettings />
              </ProtectedRoutes>
            }
          />

          <Route
            path="/messages"
            element={
              <ProtectedRoutes>
                <Conversations />
              </ProtectedRoutes>
            }
          />

          <Route
            path="/offers"
            element={
              <ProtectedRoutes>
                <ClubOffers />
              </ProtectedRoutes>
            }
          />


          <Route
            path="/offers/:id/applications"
            element={
              <ProtectedRoutes>
                <OfferApplications />
              </ProtectedRoutes>
            }
          />

          <Route
            path="/offers/:id"
            element={
              <ProtectedRoutes>
                <OfferDetails />
              </ProtectedRoutes>
            }
          />

        </Routes>

        <ConfirmModal />
        <ProfileVisitGate />
        <LoginRequiredModal />

      </LoginRequiredProvider>

    </ConfirmModalProvider>


  );
}

export default App;
